import { RotateCcw, ZoomIn, ZoomOut } from "lucide-react";
import { MAX_MAP_ZOOM, MIN_MAP_ZOOM, stepMapZoom } from "./map-zoom.js";

export function MapZoomControls({
  mapZoom,
  onZoom,
}: {
  mapZoom: number;
  onZoom: (zoom: number) => void;
}) {
  return (
    <div className="qv-map-zoom-controls" aria-label="Kartenzoom">
      <button
        type="button"
        aria-label="Karte verkleinern"
        title="Karte verkleinern"
        disabled={mapZoom <= MIN_MAP_ZOOM}
        onClick={() => onZoom(stepMapZoom(mapZoom, -1))}
      >
        <ZoomOut />
      </button>
      <output aria-live="polite">{Math.round(mapZoom * 100)}%</output>
      <button
        type="button"
        aria-label="Karte vergrößern"
        title="Karte vergrößern"
        disabled={mapZoom >= MAX_MAP_ZOOM}
        onClick={() => onZoom(stepMapZoom(mapZoom, 1))}
      >
        <ZoomIn />
      </button>
      <button
        type="button"
        aria-label="Kartenzoom zurücksetzen"
        title="Kartenzoom zurücksetzen"
        disabled={mapZoom === MIN_MAP_ZOOM}
        onClick={() => onZoom(MIN_MAP_ZOOM)}
      >
        <RotateCcw />
      </button>
    </div>
  );
}
